import { css } from "styled-components";

export const ContactAddressStyle = css`

    .contact-address__option {
        .ant-select-item-option-content {
            font-size: 12px;
        }
    }
`;
